// unique scripts go here.

const carouselInstancing = () => {
  $('.opening-banners').slick({
    fade: true,
    dots: true,
    speed: 1000,
    adaptiveHeight: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    pauseOnFocus: true,
    pauseOnDotsHover: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          autoplay: false,
        },
      },
    ],
  });

  $('.customer-carousel').slick({
    arrows: false,
    dots: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    speed: 1000,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  });

  $('.main-posts-carousel').slick({
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
  });

  $('.slider-cases').slick({
    arrows: true,
    dots: false,
    speed: 1000,
    appendArrows: $('.arrowholder'),
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          appendArrows: false,
          adaptiveHeight: true,
        },
      },
    ],
  });
  $('.slider-cases-2').slick({
    arrows: true,
    dots: false,
    speed: 1000,
    appendArrows: $('.arrowholder2'),
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          appendArrows: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  if (helpers.isMobile) {
    $('.becomes-carousel-on-mobile').slick({
      arrows: false,
      dots: false,
      speed: 1000,
      adaptiveHeight: true,
    });
  }

  $('.testimonials-carousel-cases').slick({
    dots: true,
    speed: 1000,
    arrows: false,
    adaptiveHeight: true,
  });
};

const handleAnchors = (e) => {
  e.preventDefault();

  let target = e.target;
  let attr = target.getAttribute('href');
  let scrollTo = document.getElementById(attr.replace('#', ''));

  if (helpers.wpVars.frontPage === true) {
    $('html, body').animate(
      {
        scrollTop: $(attr).offset().top - 80,
      },
      500,
    );

    if (helpers.isMobile) {
      $('.no-scroll').removeClass('no-scroll');
      $('.is-open').removeClass('is-open');
      $('.menu-open').removeClass('menu-open');
      $('.is-active').removeClass('is-active');
    }
  } else {
    window.location = `${helpers.wpVars.homeURL}${attr}`;
  }
};

const sendMail = () => {
  let forms = document.querySelectorAll('form:not(.searchform)');
  let btn;
  let btnText;

  let fetchForm = form => {
    let data = new FormData(form)
    data.append('action', 'br_submit_emails');
    let request = fetch(helpers.wpVars.adminURL, {
      method: 'POST',
      body: data,
    });

    request.then((response) => {
      Swal.fire({
        title: 'Enviado com sucesso!',
        icon: 'success',
      });

      btn.attr('disabled', false).text(btnText);
      form.reset();
    });
  };

  $(btn).attr('disabled', true).text('Enviando...');
  forms.forEach((form) =>
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      btn = $(e.target).find('button');
      btnText = btn.html();
      btn.text('Enviando...');

      fetchForm(e.target);
    }, true),
  );
};

/**
 *  Cookie related stuff
 * @param {String} name
 * @param {String} value
 * @param {Int} days
 */

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

function loadMoreMedias() {
  const btn = document.querySelector('[load-posts]')

  btn && btn.addEventListener('click', () => {
    const wrapper = document.querySelector('[posts_wrapper]')
    const formData = new FormData()
    formData.append('action', 'load_more_posts')
    formData.append('paged', btn.getAttribute('load-posts'))
    formData.append('type', btn.getAttribute('data-type'))

    btn.setAttribute('disabled', 'disabled')
    btn.textContent = 'Carregando...'
    let request = fetch(wpVars.adminURL, {
      method: 'POST',
      body: formData
    })

    request.then(response => response.text())
      .then(html => {
        if( html ) {
          console.log(html);
          wrapper.lastElementChild.insertAdjacentHTML('afterend', html)

          if( wrapper.getAttribute('posts_wrapper') == btn.getAttribute('load-posts') ) {
            btn.style.display = 'none'
          } else {
            btn.setAttribute('load-posts', parseInt(btn.getAttribute('load-posts')) + 1)
            btn.textContent = 'CARREGAR MAIS NOTÍCIAS'
            btn.removeAttribute('disabled')
          }
        }
      })
  })
}
